<template>
  <Container>
    No data available for this region
  </Container>
</template>

<script>
import { Container } from './noData.styles';

export default {
  components: { Container },
};
</script>
